import { Typography } from '../../styles';

import { StyledText } from './Styled';

const H4 = (props) => {
    return (
        <StyledText
            font={Typography.h4.fontFamily}
            size={Typography.h4.fontSize}
            color={Typography.h4.color}
            {...props}
        >
            {props.children}
        </StyledText>
    );
};

export default H4;
